:host {
  max-width: var(--wb-content-grid-max-width);
  width: var(--wb-grid-content-width);
  margin: 0 auto;
  position: relative;
  display: block;
}

:host([full-width]) {
  max-width: 100%;
  width: 100%;
}
